import { render, staticRenderFns } from "./prestationPopup.vue?vue&type=template&id=5b4bba03&scoped=true&"
import script from "./prestationPopup.vue?vue&type=script&lang=js&"
export * from "./prestationPopup.vue?vue&type=script&lang=js&"
import style0 from "./prestationPopup.vue?vue&type=style&index=0&id=5b4bba03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bba03",
  null
  
)

export default component.exports